<div>
  <div class="row m-0" *ngIf="!isRCDSS">
    <div class="p-0 {{ !!customer ? 'col-md-5 hidden-sm' : 'col-md-12' }}">
      <div class="row justify-content-center">
        <div class="col-sm-12 text-right pr-5">
          <button class="my-4 main-btn" mat-flat-button (click)="addCompany()">
            <i class="fa fa-plus"></i>
            New customer
          </button>
        </div>
      </div>

      <dx-data-grid
        #grid
        id="gridContainer"
        class="no-borders"
        [dataSource]="customers$ | async"
        (onRowClick)="openCustomer($event)"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        [selectedRowKeys]="[]"
        (onContentReady)="onContentReadyHandler($event)"
      >
        <dxo-selection mode="single"></dxo-selection>
        <dxo-pager [showNavigationButtons]="true"></dxo-pager>
        <dxo-paging [pageSize]="12"></dxo-paging>

        <dxi-column [width]="40" caption="" dataField=""></dxi-column>
        <dxi-column dataField="name"></dxi-column>
        <dxi-column dataField="city"></dxi-column>
        <dxi-column dataField="region" caption="State"></dxi-column>
        <dxi-column dataField="country"></dxi-column>
        <dxi-column dataField="priority"></dxi-column>
        <dxi-column [width]="40" caption="" dataField=""></dxi-column>

      </dx-data-grid>
    </div>

    <!-- CUSTOMER DETAILS -->
    <div class="col-md-7 left-border bounceInRight" *ngIf="!!customer && !isRCDSS">

      <div class="sticky-top p-4">
        <div class="text-right">
          <a class="btn btn-link" (click)="customer = null">
            <i class="fa fa-close ev-clickable close-icon" ></i>
          </a>
        </div>

        <mat-form-field>
          <input matInput [disabled]="!customer.can_edit" type="text" placeholder="Name" [(ngModel)]="customer.name"/>
        </mat-form-field>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="Address 1" [(ngModel)]="customer.address1"/>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="Address 2" [(ngModel)]="customer.address2"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="City" [(ngModel)]="customer.city"/>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="State" [(ngModel)]="customer.region"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="ZIP" [(ngModel)]="customer.postal_code"/>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer.can_edit" type="text" placeholder="Country" [(ngModel)]="customer.country"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input
                matInput
                [disabled]="!customer.can_edit"
                type="text"
                placeholder="Tax ID"
                [(ngModel)]="customer.government_id"
              />
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <mat-select [disabled]="!customer.can_edit" placeholder="Tax ID Type" [(ngModel)]="customer.government_id_type">
                <mat-option *ngFor="let tax of taxTypes" [value]="tax.id">
                  {{ tax.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer.can_edit"
            type="text"
            placeholder="Primary Contact Name"
            [value]="customer.contact.first_name + ' ' + customer.contact.last_name"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer.can_edit"
            type="text"
            placeholder="Primary Contact Email"
            [(ngModel)]="customer.contact.email"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer.can_edit"
            type="text"
            placeholder="Primary Contact Phone"
            [(ngModel)]="customer.contact.phone_number"
          />
        </mat-form-field>

        <mat-form-field>
          <mat-select
            [disabled]="!customer.can_edit"
            [(ngModel)]="customer.priority"
            placeholder="Priority"
          >
            <mat-option *ngFor="let priority of priorities" [value]="priority.id">
              {{ priority.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-flat-button class="main-btn" (click)="customerPOs()">
          Show Customer Purchase Orders
        </button>

        <div class="card mt-3">
          <div class="card-body">
            <div class="card-title d-flex justify-content-between">
              <h5>
                Customer-Required Files
              </h5>
            </div>

            <div class="requirement card mb-2" *ngFor="let requirement of customerRequiredFiles">
              <div class="card-header d-flex justify-content-between">
                <span>
                  {{ requirement.name }}
                </span>
                <span class="text-danger" *ngIf="requirement.is_mandatory">
                  * Mandatory
                </span>
              </div>

              <div class="card-body mb-1">

                <div *ngIf="requirement.description" class="mb-1">
                  {{ requirement.description }}
                </div>

                <ngx-supplier-file-item
                  *ngIf="requirement.document else noDocument"
                  (filesChanged)="openCustomer({'data': customer})"
                  [supplier]="customer"
                  [document]="requirement.document"
                  [companyRole]="'customer'"
                  [status]="requirement?.status"
                  [enableControls]="true">
                </ngx-supplier-file-item>

                <div class="row mt-1 mb-2" *ngIf="requirement.document && requirement.rejection_reason">
                  <div class="col-md-12">
                    <span>Rejection reason: {{ requirement.rejection_reason }}</span>
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col-md-12 actions">
                    <label class="ev-clickable mr-2" *ngIf="requirement?.status === 'pending' || requirement?.status === 'rejected'">
                      <u>
                        <i class="fa fa-paperclip"></i> {{ !requirement.document ? 'Attach' : 'Replace' }} Document
                      </u>

                      <input class="form-control" type="file" placeholder="Insurance File" hidden
                             (change)="addFile($event, requirement.id)">
                    </label>
                  </div>
                </div>

              </div>
              
            </div>
            <div class="mb-2" *ngIf="customerRequiredFiles?.length === 0">
              You have not defined any requirements for this supplier.
            </div>
          </div>
        </div>


        <!-- <div class="card my-3">
          <div class="card-body">
            <div class="card-title">
              <h5>
                Insurance Files
              </h5>

              <div class="text-center my-2">
                <label class="control-label ev-clickable">
                  <i class="fa fa-paperclip"></i> Add File
                  <input class="form-control" type="file" placeholder="Insurance File" hidden
                         (change)="addFile($event)">
                </label>
              </div>
            </div>

            <div class="mb-2" *ngFor="let document of customer.insurance_files">
              <ngx-supplier-file-item
                (filesChanged)="openCustomer({'data': customer})"
                [supplier]="customer"
                [document]="document"
                [companyRole]="'customer'"></ngx-supplier-file-item>
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>

  <div class="row m-0" *ngIf="isRCDSS && !!customer">
    <div class="col-md-12 p-4">

      <div class="sticky-top p-4 bg-white rounded shadow">

        <mat-form-field>
          <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="Name" [(ngModel)]="customer.name"/>
        </mat-form-field>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="Address 1" [(ngModel)]="customer.address1"/>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="Address 2" [(ngModel)]="customer.address2"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="City" [(ngModel)]="customer.city"/>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="State" [(ngModel)]="customer.region"/>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field>
              <input matInput [disabled]="!customer?.can_edit" type="text" placeholder="ZIP" [(ngModel)]="customer.postal_code"/>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer?.can_edit"
            type="text"
            placeholder="Contact Name"
            [value]="customer?.contact?.first_name + ' ' + customer?.contact?.last_name"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer?.can_edit"
            type="text"
            placeholder="Contact Email"
            [(ngModel)]="customer.contact.email"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            [disabled]="!customer?.can_edit"
            type="text"
            placeholder="Contact Phone"
            [(ngModel)]="customer.contact.phone_number"
          />
        </mat-form-field>

        <div class="card mt-3">
          <div class="card-body">
            <div class="card-title d-flex justify-content-between">
              <h5>
                Department-Required Files
              </h5>
            </div>

            <div class="requirement card mb-2" *ngFor="let requirement of customerRequiredFiles">
              <div class="card-header d-flex justify-content-between">
                <span>
                  {{ requirement.name }}
                </span>
                <span class="text-danger" *ngIf="requirement.is_mandatory">
                  * Mandatory
                </span>
              </div>

              <div class="card-body mb-1">

                <div *ngIf="requirement.description" class="mb-1">
                  {{ requirement.description }}
                </div>

                <ngx-supplier-file-item
                  *ngIf="requirement.document else noDocument"
                  (filesChanged)="openCustomer({'data': customer})"
                  [supplier]="customer"
                  [document]="requirement.document"
                  [companyRole]="'customer'"
                  [status]="requirement?.status"
                  [enableControls]="false">
                </ngx-supplier-file-item>

                <div class="row mt-1 mb-2" *ngIf="requirement.document && requirement.rejection_reason">
                  <div class="col-md-12">
                    <span>Rejection reason: {{ requirement.rejection_reason }}</span>
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col-md-12 actions">
                    <label class="ev-clickable mr-2" *ngIf="requirement?.status === 'pending' || requirement?.status === 'rejected'">
                      <u>
                        <i class="fa fa-paperclip"></i> {{ !requirement.document ? 'Attach' : 'Replace' }} Document
                      </u>

                      <input class="form-control" type="file" placeholder="Insurance File" hidden
                             (change)="addFile($event, requirement.id)">
                    </label>
                  </div>
                </div>

              </div>
              
            </div>
            <div class="mb-2" *ngIf="customerRequiredFiles?.length === 0">
              There aren't any requirements defined yet.
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
